import React from "react";

function SMRepLeaderboard({ items, loading, error, onRowClick, onCellClick }) {
  return (
    <div className="dashboard-card-v2">
      <div className="dashboard-card-v2-header">
        <i className="fas fa-trophy" />
        <span>Rep Leaderboard</span>
        <span className="dashboard-card-v2-count">{items.length}</span>
      </div>
      <div className="dashboard-card-v2-body">
        {error ? (
          <div className="dashboard-error">
            <i className="fas fa-exclamation-circle" /> {error}
          </div>
        ) : loading ? (
          <div className="dashboard-skeleton-list">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="dashboard-skeleton-row" />
            ))}
          </div>
        ) : items.length === 0 ? (
          <div className="dashboard-empty">
            <i className="fas fa-users" />
            <p>No active reps.</p>
          </div>
        ) : (
          <div className="sm-leaderboard-scroll">
            <table className="sm-leaderboard">
              <thead>
                <tr>
                  <th>Rep</th>
                  <th>Active</th>
                  <th>Due Today</th>
                  <th>Overdue</th>
                  <th>Won</th>
                </tr>
              </thead>
              <tbody>
                {items.map((r) => (
                  <tr
                    key={r.user_id}
                    className={`sm-leaderboard-row-clickable ${
                      Number(r.overdue) > 3 ? "row-warn" : ""
                    }`}
                    onClick={() => onRowClick && onRowClick(r)}
                  >
                    <td>
                      <div className="sm-leaderboard-name">
                        <span className="sm-leaderboard-avatar">
                          {(r.full_name || "?").charAt(0).toUpperCase()}
                        </span>
                        <span>{r.full_name}</span>
                      </div>
                    </td>
                    <td
                      onClick={(e) => {
                        e.stopPropagation();
                        onCellClick && onCellClick(r, "active");
                      }}
                      className="sm-leaderboard-cell-clickable"
                    >
                      {r.active_leads}
                    </td>
                    <td
                      onClick={(e) => {
                        e.stopPropagation();
                        onCellClick && onCellClick(r, "dueToday");
                      }}
                      className="sm-leaderboard-cell-clickable"
                    >
                      {r.due_today}
                    </td>
                    <td
                      onClick={(e) => {
                        e.stopPropagation();
                        onCellClick && onCellClick(r, "overdue");
                      }}
                      className="sm-leaderboard-cell-clickable"
                    >
                      <span className={Number(r.overdue) > 3 ? "warn-badge" : ""}>
                        {r.overdue}
                      </span>
                    </td>
                    <td
                      onClick={(e) => {
                        e.stopPropagation();
                        onCellClick && onCellClick(r, "won");
                      }}
                      className="sm-leaderboard-cell-clickable"
                    >
                      {r.won}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default SMRepLeaderboard;